
module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF
    return {
        test: /\.(txt|md)$/,
        loaders: [
        FURTHER_REF + 'raw-loader'
        ],
        exclude: /node_modules/
    }
}



// WEBPACK FOOTER //
// ./src/technologies/markdown.js